/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindAllQueryResponse, FilesControllerFindAllQueryParams, FilesControllerFindAll401, FilesControllerFindAll403 } from "../../models/filesController/FilesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerFindAll } from "../../clients/filesService/filesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerFindAllQueryKey = (params: FilesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/files'
}, ...(params ? [params] : [])] as const;
export type FilesControllerFindAllQueryKey = ReturnType<typeof filesControllerFindAllQueryKey>;
export function filesControllerFindAllQueryOptions(params?: FilesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerFindAllQueryKey(params);
  return queryOptions<FilesControllerFindAllQueryResponse, ResponseErrorConfig<FilesControllerFindAll401 | FilesControllerFindAll403>, FilesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all files
 * {@link /api/v1/files}
 */
export function useFilesControllerFindAll<TData = FilesControllerFindAllQueryResponse, TQueryData = FilesControllerFindAllQueryResponse, TQueryKey extends QueryKey = FilesControllerFindAllQueryKey>(params?: FilesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerFindAllQueryResponse, ResponseErrorConfig<FilesControllerFindAll401 | FilesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...filesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerFindAll401 | FilesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}